<template>
  <div
    class="shadow overflow-hidden rounded-md border mb-6 "
    :class="{
      'border-red-300 text-red-800 bg-red-50': type === 'error', 'border-yellow-300 text-yellow-800 bg-yellow-50': type === 'warning', 'border-blue-300 text-blue-800 bg-blue-50': type === 'info', 'border-green-300 text-green-800 bg-green-50': type === 'success',
    }"
  >
    <div class="flex">
      <div
        class="flex-shrink-0 text-white flex w-[59px] min-w-[64px] items-center justify-center"
        :class="{
          'text-red-400 bg-red-400': type === 'error', 'text-yellow-400 bg-yellow-400': type === 'warning', 'text-blue-400 bg-blue-400': type === 'info', 'text-green-400 bg-green-400': type === 'success',
        }"
      >
        <XCircleIcon
          v-if="type === 'error'"
          class="h-7 w-7 text-white"
        />
        <ExclamationIcon
          v-else-if="type === 'warning'"
          class="h-7 w-7 text-white"
        />
        <InformationCircleIcon
          v-else-if="type === 'info'"
          class="h-7 w-7 text-white"
        />
        <CheckCircleIcon
          v-else-if="type === 'success'"
          class="h-7 w-7 text-white"
        />
      </div>
      <div class="p-4">
        <h3
          v-if="title"
          class="text-sm"
          :class="{
            'text-red-800': type === 'error', 'text-yellow-800': type === 'warning', 'text-blue-800': type === 'info', 'text-green-800': type === 'success',
          }"
        >
          {{ title }}
        </h3>
        <div
          class="text-sm"
          :class="{
            'text-red-700': type === 'error', 'text-yellow-700': type === 'warning', 'text-blue-700': type === 'info', 'text-green-700': type === 'success',
          }"
        >
          <p>
            <slot />
          </p>
        </div>
      </div>
      <div
        v-if="hasDismissListener"
        class="ml-auto pl-3"
      >
        <div class="-mx-1.5 -my-1.5">
          <button
            type="button"
            class="inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2"
            :class="{
              'text-red-500 hover:bg-red-100 bg-red-50 focus:ring-offset-red-50 focus:ring-red-600': type === 'error', 'text-yellow-600 hover:bg-yellow-100 bg-yellow-50 focus:ring-offset-yellow-50 focus:ring-yellow-600': type === 'warning', 'text-blue-600 hover:bg-blue-100 bg-blue-50 focus:ring-offset-blue-50 focus:ring-blue-600': type === 'info', 'text-green-600 hover:bg-green-100 bg-green-50 focus:ring-offset-green-50 focus:ring-green-600': type === 'success',
            }"
            @click="$emit('dismiss')"
          >
            <span class="sr-only">Dismiss</span>
            <!-- Heroicon name: solid/x -->
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon, XCircleIcon } from '@heroicons/vue/outline';
import { ExclamationIcon, InformationCircleIcon } from '@heroicons/vue/solid';

export default {
  components: {
    CheckCircleIcon,
    XCircleIcon,
    ExclamationIcon,
    InformationCircleIcon,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'info',
    },
  },
  emits: ['dismiss'],
  computed: {
    hasDismissListener() {
      return !!this.$attrs.onDismiss;
    },
  },
};
</script>
